import { useCallback, useSyncExternalStore } from 'react';

const FORM_ID_PARAM = 'formId';

const listeners = new Set<() => void>();

const notify = () => listeners.forEach(listener => listener());

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  window.addEventListener('popstate', listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('popstate', listener);
  };
};

const getSnapshot = (): number | undefined => {
  const raw = new URLSearchParams(window.location.search).get(FORM_ID_PARAM);
  const parsed = raw ? Number(raw) : NaN;
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
};

const getServerSnapshot = (): number | undefined => undefined;

export function useWellnessFormId(): [
  formId: number | undefined,
  setFormId: (formId: number | undefined) => void,
] {
  const formId = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const setFormId = useCallback((next: number | undefined) => {
    const searchParams = new URLSearchParams(window.location.search);
    if (next === undefined) {
      searchParams.delete(FORM_ID_PARAM);
    } else {
      searchParams.set(FORM_ID_PARAM, String(next));
    }
    const qs = searchParams.toString();
    const newUrl = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
    notify();
  }, []);

  return [formId, setFormId];
}
